import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
}), 'Send');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/Send.js
// module id = 5968
// module chunks = 2